const AUTH_BASE = '/auth';
const PROFILE_BASE = '/profile';
const ORGANIZATIONS_BASE = '/organizations';
const SITES_BASE = '/sites';
const USERS_BASE = '/user-management';
const QUESTIONNAIRE_BASE = '/questionnaire';
const GROUPS_BASE = '/user-groups';
const NOTIFICATIONS_BASE = '/notifications';
const BRANDING_BASE = '/branding';
const RISK_BASE = '/risk';
const RECOVERY_BIN_BASE = '/recovery-bin';

export const ROUTES = {
  AUTH: {
    LOGIN: `${AUTH_BASE}/login`,
    LOGOUT: `${AUTH_BASE}/logout`,
  },
  PROFILE: {
    BASE: PROFILE_BASE,
  },
  ORGANIZATIONS: {
    BASE: ORGANIZATIONS_BASE,
    LIST: ORGANIZATIONS_BASE,
    ITEM: `${ORGANIZATIONS_BASE}/:id`,
    CREATE: `${ORGANIZATIONS_BASE}/create`,
  },
  SITES: {
    BASE: SITES_BASE,
    LIST: SITES_BASE,
    ITEM: `${SITES_BASE}/:id`,
    CREATE: `${SITES_BASE}/create`,
  },
  USERS: {
    BASE: USERS_BASE,
    LIST: USERS_BASE,
    ITEM: `${USERS_BASE}/:id`,
    CREATE: `${USERS_BASE}/create`,
  },
  GROUPS: {
    BASE: GROUPS_BASE,
    LIST: GROUPS_BASE,
    ITEM: `${GROUPS_BASE}/:id`,
    USER_LIST: `${GROUPS_BASE}/:id/list`,
    CREATE: `${GROUPS_BASE}/create`,
  },
  QUESTIONNAIRE: {
    GENERAL: QUESTIONNAIRE_BASE,
    INVITATION: `${QUESTIONNAIRE_BASE}/invitation`,
    HELP_CONTACT: `${QUESTIONNAIRE_BASE}/help-contact`,
  },
  NOTIFICATIONS: {
    BASE: NOTIFICATIONS_BASE,
  },
  BRANDING: {
    BASE: BRANDING_BASE,
    DASHBOARD: `${BRANDING_BASE}/dashboard`,
    QUESTIONNAIRE: `${BRANDING_BASE}/questionnaire`,
  },
  RISK: {
    BASE: RISK_BASE,
  },
  RECOVERY_BIN: {
    BASE: RECOVERY_BIN_BASE,
  },
};

export default ROUTES;
